/**
 * Insight Skill Area
 * Lessons focused on research, reflection, and generating insights
 */

export { impactReflection } from './impact-reflection';
export { researchBriefLab } from './research-brief-lab';

import { impactReflection } from './impact-reflection';
import { researchBriefLab } from './research-brief-lab';
import type { LessonDefinition } from '../types';

export const insightLessons: LessonDefinition[] = [
  impactReflection,
  researchBriefLab,
];
